<template>
  <div @click="hideOrderComment" class="detail-container">
    <div @click.stop class="detail-view">
      <div class="bg"/>
      <div class="meal-info">
        <span class="title">{{ $store.state.comment_need_data.order_info[0].busi_name }}</span>
        <img class="img" :src="imgUrl" @error="errorLoadImg()">
      </div>
      <div class="comment-title-container"><span class="comment-title">本次用餐体验还满意么？</span></div>
      <div class="comment-view-container">
        <div v-for="(item, indexs) in orderDatas" :key="indexs" class="comment-view">
          <span class="title-star">
            <span class="title">{{ item.menu_name }}</span>
            <Stars class="star" :starIndex="indexs" :stars="$store.state.user.order.stars[indexs]" :starWidth="starWidth" :starMargin="starMargin" :clickable="clickable" />
          </span>
          <textarea v-model="comments[indexs]" class="textarea" autofocus placeholder="留下你宝贵的意见，帮小伙伴们选择"/>
        </div>
        <div v-if="$store.state.comment_need_data.select_typename === '试吃'" class="try-eat-view">
          <span class="title-view">
            <img class="icon" src="../../../static/img/user/icon_wdpj_dp.png">
            <span class="title-text">餐馆评价</span>
            <span class="text">(每项都要评论哦)</span>
          </span>
          <div v-for="(items, index) in tryEatEvaluationDats" :key="index" class="evaluation">
            <span class="title">{{ items.title }}</span>
            <div class="evaluation-item-container">
              <div
                v-for="(item, i) in items.count"
                :key="i + 10"
                @click="changeEvaluation(index, i)"
                class="evaluation-item"
                :class="{
                          left: i !== 0,
                          evaluationActive: i === evaluationActiveArr[index],
                          first: i === 0 && i !== evaluationActiveArr[index],
                          firstActive: i === 0 && i === evaluationActiveArr[index],
                          last: i === items.count - 1 && i !== evaluationActiveArr[index],
                          lastActive: i === items.count - 1 && i === evaluationActiveArr[index],
                          lastFirst: index === tryEatEvaluationDats.length - 1 && i === 0,
                          lastFirstActive: index === tryEatEvaluationDats.length - 1 && i === 0 && i === evaluationActiveArr[index],
                          lastSecond: index === tryEatEvaluationDats.length - 1 && i === 1,
                          lastSecondActive: index === tryEatEvaluationDats.length - 1 && i === 1 && i === evaluationActiveArr[index]
                        }"
              />
            </div>
          </div>
        </div>
      </div>
      <div @click="createEvaluationData" class="publish-btn">{{ publishing ? '发布中...' : '发布' }}</div>
    </div>
  </div>
</template>

<script>
import Stars from '@/components/common/stars'

export default {
  name: 'OrderComment',
  components: {
    Stars
  },
  data () {
    return {
      starWidth: 24,
      starMargin: 10,
      clickable: true,
      comments: [],
      publishing: false,
      evaluationActiveArr: [-1, -1, -1, -1, -1, -1, -1, -1, -1],
      tryEatEvaluationDats: [
        {
          title: '主菜',
          count: 3
        },
        {
          title: '配菜',
          count: 3
        },
        {
          title: '例汤',
          count: 3
        },
        {
          title: '口味',
          count: 3
        },
        {
          title: '米饭',
          count: 3
        },
        {
          title: '菜量',
          count: 3
        },
        {
          title: '新鲜',
          count: 3
        },
        {
          title: '卫生',
          count: 3
        },
        {
          title: '意见',
          count: 2
        }
      ]
    }
  },
  computed: {
    imgUrl () {
      return this.$store.state.comment_need_data.order_info[0].menu[0].menu_photo ? this.$store.state.comment_need_data.order_info[0].menu[0].menu_photo : '../../../static/img/meals/pic_home_default.png'
    },
    /**
     * 订单内菜品数据
     */
    orderDatas () {
      let orderArr = []
      this.$store.state.comment_need_data.order_info.map((items) => {
        items.menu.map((item) => {
          orderArr.push(item)
        })
      })
      return orderArr
    }
  },
  methods: {
    /**
     * 隐藏评价弹窗
     */
    hideOrderComment () {
      this.comments = []
      this.$store.commit('clear_active_stars')
      this.$store.commit('toggle_show_order_comment')
    },
    /**
     * 生成评论数据
     */
    createEvaluationData () {
      // 订单内菜品总数
      let menuLength = this.orderDatas.length
      // 检查数据合法性
      if (this.comments.length !== menuLength || this.$store.state.user.order.stars.length !== menuLength) {
        this.$store.commit('show_alert', '请填写完整信息呦')
        return
      } else {
        // 防止用户输入信息后再撤销时评论为空的情况
        let commentFlag = false
        // 如果有两个菜品，只评论了第二个，那么评论数组的第一个元素将会为空值，遍历时空值被跳过，用ES6的扩展运算符将空值转化为undefined
        let commentArr = [...this.comments]
        commentArr.map((item, index) => {
          if (!item || item.length === 0) {
            commentFlag = true
          }
        })
        if (commentFlag) {
          this.$store.commit('show_alert', '评论不能为空呦')
          return
        }
        // 星星信息
        let starFlag = false
        let starArr = [...this.$store.state.user.order.stars]
        starArr.map((item, index) => {
          if (!item || item.length === 0) {
            starFlag = true
          }
        })
        if (starFlag) {
          this.$store.commit('show_alert', '别忘记了评分呦')
          return
        }
      }
      let commonOrder = true
      let isFullSelected = true
      // 根据条件判断是否为试吃订单
      if (this.$store.state.comment_need_data.select_typename === '试吃') {
        commonOrder = false
      }
      if (!commonOrder) {
        this.evaluationActiveArr.map((item, index) => {
          if (item == -1) {
            isFullSelected = false
          }
        })
      }
      if (!isFullSelected) {
        this.$store.commit('show_alert', '试吃评价要全部选择呦')
        return
      }
      // 生成评论数据
      let params = {
        order_discuss: [],
        order_id: this.$store.state.comment_need_data.order_id,
        user_id: this.$store.state.user_info.id
      }
      this.orderDatas.map((item, index) => {
        let info = {
          busi_id: item.busi_id,
          comment: this.comments[index],
          menu_id: item.menu_id,
          menu_spec_id: item.menu_spec_id,
          score: this.$store.state.user.order.stars[index] * 2
        }
        params.order_discuss.push(info)
      })
      if (commonOrder) {
        // 不是试吃订单，直接提交
        this.commonOrderEvaluate(params)
      } else {
        // 是试吃订单，添加试吃评论数据
        params.attitude = (this.evaluationActiveArr[8] + 1).toString()
        params.content_body = {
          comment: '',
          main_course: (this.evaluationActiveArr[0] + 1).toString(),
          side_dish: (this.evaluationActiveArr[1] + 1).toString(),
          soup: (this.evaluationActiveArr[2] + 1).toString(),
          taste: (this.evaluationActiveArr[3] + 1).toString(),
          rice_taste: (this.evaluationActiveArr[4] + 1).toString(),
          dish_portion: (this.evaluationActiveArr[5] + 1).toString(),
          dish_fresh: (this.evaluationActiveArr[6] + 1).toString(),
          health: (this.evaluationActiveArr[7] + 1).toString(),
        }
        this.tryEatEvaluate(params)
      }
    },
    /**
     * 日常订单评价
     */
    commonOrderEvaluate (params) {
      this.publishing = true
      this.APIS.ORDER_COMMENT(params)
      .then((res) => {
        this.publishing = false
        if (res.data.status === 0) {
          // 调用父组件方法更新订单列表
          this.$emit('getOrders')
          this.$store.commit('show_alert', '订单评论成功')
          this.hideOrderComment()
        } else {
          this.$store.commit('show_alert', '订单评论失败')
        }
      })
      .catch(() => {
        this.publishing = false
        this.$store.commit('show_alert', '订单评论失败')
      })
    },
    /**
     * 试吃评价
     */
    tryEatEvaluate (params) {
      this.publishing = true
      this.APIS.TRY_EAT_ORDER_COMMENT(params)
      .then((res) => {
        this.publishing = false
        if (res.data.status === 0) {
          // 调用父组件方法更新订单列表
          this.$emit('getOrders')
          this.$store.commit('show_alert', '订单评论成功')
          this.hideOrderComment()
        } else {
          this.$store.commit('show_alert', '订单评论失败')
        }
      })
      .catch(() => {
        this.publishing = false
        this.$store.commit('show_alert', '订单评论失败')
      })
    },
    /**
     * 改变试吃评价选项
     */
    changeEvaluation (index ,i) {
      this.evaluationActiveArr.splice(index, 1, i)
    },
    /**
     * 如果图片加载出错，显示默认图片
     */
    errorLoadImg () {
      const eventTag = event.toElement || event.target;
      eventTag.src = "../../../static/img/meals/pic_home_default.png"
    }
  }
}
</script>

<style lang="less" scoped>
.detail-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba( 0, 0, 0, .5);
  z-index: 1001;
  overflow: auto;
  cursor: pointer;
  .detail-view {
    width: 520px;
    height: 860px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    border-radius: 10px;
    cursor: default;
    .bg {
      width: 520px;
      height: 200px;
      background: url("../../../static/img/meals/bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .meal-info {
      width: 440px;
      height: 400px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #ffffff;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      margin-top: -160px;
      .title {
        font-size: 24px;
        color: #333333;
        margin-top: 20px;
      }
      .img {
        width: 280px;
        height: 280px;
        border-radius: 140px;
        margin-top: 20px;
      }
    }
    .comment-title-container {
      width: 460px;
      margin-top: 40px;
      .comment-title {
        font-size: 24px;
        color: #333333;
        font-weight: bold;
      }
    }
    .comment-view-container {
      width: 100%;
      height: 230px;
      margin-top: 10px;
      overflow-x: auto;
      .comment-view {
        width: 460px;
        display: flex;
        flex-direction: column;
        margin-left: 30px;
        .title-star {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 16px;
          .star {
            margin-left: 12px;
          }
          .title {
            font-size: 20px;
            color: #333333;
          }
        }
        .textarea {
          width: calc(~"100% - 18px");
          height: 140px;
          background-color: #f4f4f4;
          border-radius: 4px;
          margin-top: 20px;
          font-family:"Microsoft Yahei";
          font-size: 16px;
          padding-top: 10px;
          padding-left: 16px;
          resize: none;
          border: 0;
        }
      }
      .try-eat-view {
        display: flex;
        flex-direction: column;
        margin-left: 30px;
        margin-top: 30px;
        .title-view {
          height: 20px;
          display: flex;
          align-items: center;
          .icon {
            width: 20px;
            height: 20px;
          }
          .title-text {
            margin-left: 10px;
            font-size: 18px;
            color: #333333;
          }
          .text {
            font-size: 18px;
            color: #999999;
          }
        }
        .evaluation {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 16px;
          .title {
            font-size: 16px;
            color: #000000;
          }
          .evaluation-item-container {
            display: flex;
            flex-direction: row;
            margin-left: 16px;
            .evaluation-item {
              width: 88px;
              height: 28px;
              cursor: pointer;
              background-image: url('../../../static/img/user/btn_yb.png')
            }
            .evaluationActive {
              background-image: url('../../../static/img/user/btn_yb_sel.png')
            }
            .first {
              background-image: url('../../../static/img/user/btn_hp.png')
            }
            .firstActive {
              background-image: url('../../../static/img/user/btn_hp_sel.png')
            }
            .last {
              background-image: url('../../../static/img/user/btn_cp.png')
            }
            .lastActive {
              background-image: url('../../../static/img/user/btn_cp_sel.png')
            }
            .lastFirst {
              background-image: url('../../../static/img/user/btn_tj.png')
            }
            .lastFirstActive {
              background-image: url('../../../static/img/user/btn_tj_sel.png')
            }
            .lastSecond {
              background-image: url('../../../static/img/user/btn_jj.png')
            }
            .lastSecondActive {
              background-image: url('../../../static/img/user/btn_jj_sel.png')
            }
            .left {
              margin-left: 48px;
            }
          }
        }
      }
    }
    .publish-btn {
      width: 460px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      color: #ffffff;
      background-color: #ff9a28;
      border-radius: 30px;
      margin-top: 25px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/order_comment.vue